module.exports = __webpack_public_path__ + "img/stars.bea850d9.png";